// extracted by mini-css-extract-plugin
export default {"root":"NoWithdrawalsYet_root__liKGB","content":"NoWithdrawalsYet_content__ZXT2X","message":"NoWithdrawalsYet_message__0nrqZ"};